import { useMemo } from 'react'
import { Container, Text } from '@pixi/react'
import { paragraphStyle, tableTitleStyle } from './textStyle'
import { ParagraphProps } from './Paragraph2'
import { t } from '@slot-nx/core'

export const Paragraph7 = (props: ParagraphProps) => {
  const content = useMemo(() => {
    return (
      <Container y={props.y}>
        <Text
          text={t('gameRules_title5')}
          anchor={[0.5, 0]}
          x={props.width / 2}
          style={tableTitleStyle}
        />
        <Text
          x={60}
          y={120}
          text={t('gameRules_title5_content_1')}
          style={paragraphStyle}
        />
      </Container>
    )
  }
  , [])
  return content
}
